"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Plants_1 = __importDefault(require("../Pages/Plants"));
const PlantOptions_1 = __importDefault(require("../Pages/PlantOptions"));
const Images_1 = __importDefault(require("../Pages/Images"));
const Presets_1 = __importDefault(require("../Pages/Presets"));
const Login_1 = __importDefault(require("../Pages/Login"));
const Route_1 = __importDefault(require("./Route"));
const Authors_1 = __importDefault(require("../Pages/Authors/Authors"));
const Users_1 = __importDefault(require("../Pages/Users"));
const Companies_1 = __importDefault(require("../Pages/Companies"));
const Inventory_1 = __importDefault(require("../Pages/Inventory"));
const Orders_1 = __importDefault(require("../Pages/Orders"));
const ScannerV2_1 = __importDefault(require("../Pages/Scanner/ScannerV2"));
const DashboardPage_1 = __importDefault(require("../Pages/Dashboard/DashboardPage"));
const OrderFullFillments_1 = __importDefault(require("../Pages/OrderFullFillments"));
const OrderHistory_1 = __importDefault(require("../Pages/OrderHistory"));
const Catalogs_1 = __importDefault(require("../Pages/Catalogs"));
const Routes = () => {
    return (react_1.default.createElement(react_router_dom_1.Switch, null,
        react_1.default.createElement(Route_1.default, { path: "/plants", component: Plants_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/plant-options", component: PlantOptions_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/pictures", component: Images_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/presets", component: Presets_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/authors", component: Authors_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/users", component: Users_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/companies", component: Companies_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/inventory", component: Inventory_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/catalogs", component: Catalogs_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/orders", component: Orders_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/orders-fullfillments", component: OrderFullFillments_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/orders-history", component: OrderHistory_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/inventory-scanner", component: ScannerV2_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { path: "/login", component: Login_1.default }),
        react_1.default.createElement(Route_1.default, { path: "/", component: DashboardPage_1.default, isPrivate: true }),
        react_1.default.createElement(Route_1.default, { component: Login_1.default })));
};
exports.default = Routes;
